import { render, staticRenderFns } from "./CreditLimitModal.vue?vue&type=template&id=29fd092d&scoped=true"
import script from "./CreditLimitModal.vue?vue&type=script&lang=js"
export * from "./CreditLimitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fd092d",
  null
  
)

export default component.exports